import { getTitleFontSize } from '@/lib/utils/typography';

export const WINDOW_COLLAPSE_MS = 300;
export const WINDOW_TITLE_PADDING_Y = 24;
export const VIDEO_CONTROLS_HEIGHT = 42;

export function getWindowSize(widthContent: number, widthRatio: number, mediaAspectRatio: number) {
  const width = Math.ceil(widthContent * widthRatio);
  const titleBarHeight = getTitleFontSize(widthContent) + WINDOW_TITLE_PADDING_Y;
  return {
    width,
    height: Math.ceil(width * mediaAspectRatio) + titleBarHeight,
  };
}
